import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  CircularProgress,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import propTypes from 'prop-types';

function LogoutModal({ isDialogOpen, handleDialogClose, handleLogoutConfirm, isLoading = false }) {
  return (
    <Dialog
      PaperProps={{ sx: { width: 400, maxWidth: '100%' } }}
      open={isDialogOpen}
      onClose={handleDialogClose}
      className="popupStyles logoutPopup"
    >
      <DialogTitle
        className="pb-0"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '15px 16px 16px',
        }}
      >
        Confirm Logout
        <IconButton
          edge="end"
          onClick={handleDialogClose}
          size="small"
          sx={{ position: 'relative', right: '-5px', top: '-5px' }}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent className="py-1" sx={{ padding: '16px' }}>
        <DialogContent className="px-0 pt-0">Are you sure you want to logout?</DialogContent>
      </DialogContent>

      <DialogActions sx={{ padding: '10px 16px 18px' }}>
        <Button onClick={handleDialogClose} variant="outlined" className="popupActionBtn btnGrey">
          Cancel
        </Button>
        <Button
          onClick={handleLogoutConfirm}
          variant="contained"
          className="popupActionBtn"
          color="primary"
          disabled={isLoading}
          startIcon={isLoading ? <CircularProgress size={14} /> : null}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}

LogoutModal.propTypes = {
  handleDialogClose: propTypes.func.isRequired,
  handleLogoutConfirm: propTypes.func.isRequired,
  isDialogOpen: propTypes.bool.isRequired,
  isLoading: propTypes.bool,
};

export default LogoutModal;
